

export interface TriStateToggleProps {
    style?: React.CSSProperties;
    selection: boolean | null | undefined;
    trueLabel?: string;
    falseLabel?: string;
    onSelectionChange?: (selection: boolean | null) => void;
    onFocus?: () => void;
    allowNull?: boolean;
    disabled?: boolean;
    readonly?: boolean;
}

export function TriStateToggle({
    style,
    selection,
    trueLabel = 'Yes',
    falseLabel = 'No',
    onSelectionChange,
    onFocus,
    allowNull = true,
    disabled,
    readonly,
}: TriStateToggleProps) {

    function handleSelectYes() {
        if (readonly) return;
        const newSelection = (allowNull && selection === true) ? null : true;
        onSelectionChange?.(newSelection);
    }

    function handleSelectNo() {
        if (readonly) return;
        const newSelection = (allowNull && selection === false) ? null : false;
        onSelectionChange?.(newSelection);
    }

    return (
        <span className='tristate-toggle' style={style}>
            <button
                className={`toggle-option--yes ${selection === true ? 'selected' : ''}`}
                type='button'
                onClick={handleSelectYes}
                onFocus={onFocus}
                disabled={disabled}
                children={trueLabel}
            />
            <button
                className={`toggle-option--no ${selection === false ? 'selected' : ''}`}
                type='button'
                onClick={handleSelectNo}
                onFocus={onFocus}
                disabled={disabled}
                children={falseLabel}
            />
        </span>
    );
}
